import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=58729428&scoped=true&"
var script = {}
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=58729428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58729428",
  null
  
)

component.options.__file = "HeaderComponent.vue"
export default component.exports